import { render, staticRenderFns } from "./CongratulationsPage.vue?vue&type=template&id=eb4ccc02&scoped=true"
import script from "./CongratulationsPage.vue?vue&type=script&lang=js"
export * from "./CongratulationsPage.vue?vue&type=script&lang=js"
import style0 from "./CongratulationsPage.vue?vue&type=style&index=0&id=eb4ccc02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4ccc02",
  null
  
)

export default component.exports